@let shippingFinalizingState = shippingFinalizingState$ | async;
<!--  -->
@if (!shippingFinalizingState?.loading && !shippingFinalizingState?.failed) {
<header class="shipping-details-header">
  <div class="shipping-details-header__container">
    <div class="shipping-details-header__logotype">
      <peca-logotype />
    </div>
    <div class="shipping-details-header__identity">
      <h2 class="shipping-details-header__identity__title">{{ shipping.orderId }}</h2>
    </div>
  </div>
</header>

<main class="shipping-details">
  <div class="shipping-details__map">
    <peca-google-maps (loaded)="onGoogleMapsLoad()" />
  </div>
  <div class="shipping-details__route">
    @for (stop of shipping.stops; track $index) {
    <peca-shipping-stop [stop]="stop" [carrier]="shipping.carrier ?? 'self-shipping'" (finalize)="onClickFinalizeStop($event)" />
    }
  </div>
</main>
} @else if (shippingFinalizingState?.loading) {
<peca-shipping-loader />
} @else if (shippingFinalizingState?.failed) {
<peca-shipping-failed [title]="finalizeFailure?.title ?? 'Falha ao finalizar a entrega'" [description]="finalizeFailure?.description ?? 'Não foi possível finalizar sua entrega. Tente novamente e caso o problema persistir, por favor, entre em contato com o suporte.'" (retry)="onRetry()" />
}
